import React from 'react';
import FormPanel from '../../common/form/FormPanel';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';

export default () => {
    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget name="label" label="Label" />
                </FormItem>
                <FormItem>
                    <FormWidget name="group" label="Group" />
                </FormItem>
                <FormItem>
                    <FormWidget name="description" component="TextArea" label="Description" />
                </FormItem>
                <FormItem half>
                    <FormWidget name="min" label="Min" />
                </FormItem>
                <FormItem half>
                    <FormWidget name="max" label="Max" />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
